module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ui":{"components":{"start":{"news":{"button":"View all articles","description":"Selected articles by our experts and partners","title":"Top topics of the week"}}}}}}')
  delete Component.options._Ctor
}
